export default {
  steps: {
    discount: 'Discount',
    mobile_app: 'Mobile app',
    business_info: 'Business info',
    create_preview: 'Create preview contract',
    preview: 'Preview contract',
    sign: 'Sign contract',
  },
  buttons: {
    back: 'Back',
    continue: 'Continue',
  },
  agreement:
    'Switching to annual applies the {{discount}}% discount to your {{plan}} plan. Your billing continues monthly at {{amount}} per month under a {{months}}-month commitment.',
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    failed_to_switch: 'Failed to switch to annual',
    switched_to_annual: 'Contract switched to annual 👌',
  },
};
